import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../styles/Auth.css"; 
import axios from "axios";
const logo = "/images/Logo.svg"; 

const API = process.env.REACT_APP_API_URL || "";

const VerifyEmail = () => {
    const [status, setStatus] = useState("loading");
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");
    const inviteToken = searchParams.get("invite");

    useEffect(() => {
        let redirectTimer;

        if (!token) {
            setStatus("noToken");
            return;
        }

        axios.get(`${API}/api/auth/verify?token=${encodeURIComponent(token)}`)
            .then(() => {
                setStatus("success");
                const loginPath = inviteToken
                    ? `/?invite=${encodeURIComponent(inviteToken)}&mode=login`
                    : "/";
                redirectTimer = setTimeout(() => navigate(loginPath), 3000);
            })
            .catch(() => {
                setStatus("error");
            });

        return () => clearTimeout(redirectTimer);
    }, [token, inviteToken, navigate]);

    return (
        <div className="verify-container">
            <div className="logo-area">
                <img src={logo} alt="Festzeltfinanzen Logo" className="logo" />
            </div>
            <div className="verify-area">
                <div className="verify-content">
                    {status === "loading" && <p>Verifiziere deine E-Mail...</p>}
                    {status === "success" && <p>E-Mail bestätigt! Du wirst in 3 Sekunden zum Login weitergeleitet.</p>}
                    {status === "error" && <p>Fehler: Der Verifizierungslink ist ungültig oder abgelaufen.</p>}
                    {status === "noToken" && (
                        <div className="verify-message">
                            <h2>📩 Fast geschafft! Bitte bestätige deine E-Mail-Adresse</h2>
                            <p>Danke für deine Registrierung! Bevor du dich einloggen kannst, musst du deine E-Mail-Adresse bestätigen.</p>
                            
                            <ul>
                                <li><strong>✅ Bestätigungsmail gesendet:</strong> Wir haben dir eine E-Mail mit einem Bestätigungslink geschickt.</li>
                                <li><strong>📥 Spam-Ordner prüfen:</strong> Falls du die E-Mail nicht siehst, überprüfe bitte deinen Spam-Ordner.</li>
                                <li><strong>⏳ Link ist zeitlich begrenzt:</strong> Bestätige deine E-Mail so schnell wie möglich.</li>
                            </ul>

                            <p>Sobald du deine E-Mail bestätigt hast, kannst du dich mit deinen Zugangsdaten einloggen.</p>

                            <h3>📩 Keine E-Mail erhalten?</h3>
                            <p>Falls du nach ein paar Minuten noch nichts bekommen hast, kannst du die Registrierung erneut durchführen oder dich an den Support wenden.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
